export default __webpack_public_path__ + "static/img3-79ac33868bcc4ab70e53f74dbf1e4e40.jpg";